'use client'

import { useBlogScript } from './blog-script-provider'
import { cn } from '@/lib/utils'
import { IconArrowsExchange } from '@tabler/icons-react'
import { useState } from 'react'

interface HanziProps {
  s: string // Simplified
  t: string // Traditional
  className?: string
}

export function Hanzi({ s, t, className }: HanziProps) {
  const { script, toggleScript } = useBlogScript()
  const [isHovered, setIsHovered] = useState(false)
  const displayText = script === 'simplified' ? s : t

  return (
    <span
      className={cn('relative inline-block', className)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {displayText}
      {isHovered && (
        <button
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            toggleScript()
          }}
          className="bg-background/60 border-border/30 absolute -top-0.5 -right-0.5 z-10 flex h-3.5 w-3.5 items-center justify-center rounded-full border opacity-40 shadow-xs backdrop-blur-sm transition-opacity hover:opacity-80"
          aria-label={`Switch to ${script === 'simplified' ? 'traditional' : 'simplified'} script`}
          title={`Switch to ${script === 'simplified' ? 'traditional' : 'simplified'} script`}
        >
          <IconArrowsExchange className="text-foreground/50 h-2 w-2" />
        </button>
      )}
    </span>
  )
}
